<template>
  <div>
    <Modal
      :styles="{
        top: '20px',
        width: 'auto',
        maxWidth: '1030px'
      }"
      :value="true"
      :closable="false"
      :mask-closable="false"
      class="stats-modal"
    >
      <Spin v-if="loading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>
      <div
        slot="header"
        class="d-flex justify-content-between align-items-center"
      >
        <h5 style="margin-bottom: 0;">
          {{ $t("club.table.stats") }} | {{ $t("menu.teams-table") }}
        </h5>
        <Button
          @click="() => $emit('close', false)"
          type="text"
          icon="md-close"
          class="modal-close-btn"
        ></Button>
      </div>
      <div class="table-special-div">
        <!-- <table class="table-stats dt-responsive nowrap w-100 ml-0"> -->
        <table
          v-if="!loading"
          ref="myTable"
          class="table-stats table table-bordered dt-responsive table-striped nowrap w-100 ml-0"
        >
          <thead>
            <tr>
              <th rowspan="2" style="width: 150px; min-width: 150px;">
                {{ $t("menu.team") }}
              </th>
              <th
                v-for="(stage, index) in competition.stages.filter(
                  stage => stage.category === category
                )"
                colspan="2"
              >
                {{ $t("competition.stage") }} {{ index + 1 }}
              </th>
              <th colspan="2">{{ $t("competition.total") }}</th>
            </tr>
            <tr>
              <template
                v-for="(stage, index) in competition.stages.filter(
                  stage => stage.category === category
                )"
              >
                <th>{{ $t("competition.points") }}</th>
                <th>{{ $t("competition.diff") }}</th>
              </template>
              <th>{{ $t("competition.points") }}</th>
              <th>{{ $t("competition.diff") }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(team, index) in teams">
              <tr :key="team._id">
                <td>
                  <Tooltip
                    :content="team.name"
                    placement="top-start"
                    style="width: 170px;"
                  >
                    <span
                      class="text-overflow-style single-groups-clamp-text w-100"
                    >
                      {{ team.name }}
                    </span>
                  </Tooltip>
                </td>
                <template
                  v-if="team.statistics"
                  v-for="stage in team.statistics ? team.statistics.stages : []"
                >
                  <td>
                    <span v-if="stage">{{ stage.points }}</span>
                    <span v-else></span>
                  </td>
                  <td>
                    <div
                      v-if="stage"
                      class="d-flex justify-content-between w-100 text-nowrap"
                    >
                      <span class="mr-2">
                        {{ stage.scored }} - {{ stage.conceded }}
                      </span>
                      <span class="font-weight-bold">
                        ({{ displayPlus(stage.scored, stage.conceded) }})
                      </span>
                    </div>
                    <span v-else></span>
                  </td>
                </template>
                <td>
                  <span v-if="team.statistics">{{
                    team.statistics.totalPoints
                  }}</span>
                </td>
                <td>
                  <div
                    v-if="team.statistics"
                    class="d-flex justify-content-between w-100 text-nowrap"
                  >
                    <span class="mr-2">
                      {{ team.statistics.totalScored }} -
                      {{ team.statistics.totalConceded }}
                    </span>
                    <span class="font-weight-bold">
                      ({{
                        displayPlus(
                          team.statistics.totalScored,
                          team.statistics.totalConceded
                        )
                      }})
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div slot="footer" class="text-center"></div>
    </Modal>
  </div>
</template>
<script>
import bracketsMixin from "./bracketsMixin";
export default {
  name: "StatsModal",
  data() {
    return bracketsMixin;
  },
  methods: {
    // async getGoalsByStages() {
    // 	this.loading = true;
    // 	for (let team of this.teams) {
    // 		for (let i = 0; i < this.competition.stages.length; i++) {
    // 			const element = this.competition.stages[i];
    // 			try {
    // 				const res = await this.$http.post('/team/stages', { teamId: team._id, stageId: element._id });
    // 				console.log(res.data);
    // 			} catch (error) {
    // 				console.log(error);
    // 			}
    // 		}
    // 	}
    // 	this.loading = false;
    // },
  },
  async created() {
    // this.statsPoints = [];
    // await this.getGoalsByStages();
    await this.getCurrentTeams(true);
    this.teams.sort(this.sortByTotalStats);
  }
};
</script>
<style scoped>
table.table-stats {
  /* background: #454751; */
  border-radius: 0.25em;
  border-collapse: collapse;
  /* margin: 1em; */
}

/* .table-stats th {
		border: 1px solid #364043;
		color: #eee;
		font-size: 0.85em;
		font-weight: 600;
		padding: 0.5em 1em;
		text-align: center;
		opacity: 0.75;
	} */
/* .table-stats td {
		color: #fff;
		font-weight: 400;
		padding: 0.65em 1em;
		text-align: center;
	} */
.disabled td {
  color: #4f5f64;
}

.table-stats tbody tr {
  transition: background 0.25s ease;
}

.stats-modal :global(.ivu-modal) {
  width: max-content !important;
}
.stats-modal :global(.ivu-modal-content) {
  min-width: 368px;
  min-height: 368px;
}
.stats-modal .table-striped tbody tr:nth-of-type(odd):hover,
.table-stats tbody tr:hover {
  background: #555862 !important;
}

.stats-modal :global(.ivu-modal-header) {
  padding-bottom: 0;
}

.stats-modal :global(.ivu-modal-header),
.stats-modal :global(.ivu-modal-footer) {
  border: none;
}

.stats-modal :global(.ivu-modal-footer) {
  padding: 0;
}

.stats-modal :global(.ivu-modal-content) {
  background: #454751;
  border: 1px solid #272727;
}

.stats-modal h5,
.stats-modal table td,
.stats-modal table th,
.stats-modal button {
  color: #ffffff !important;
}

.stats-modal button:hover {
  filter: brightness(0.8);
  color: #ffffff !important;
}

.stats-modal button {
  background: #454751 !important;
}

.stats-modal :global(.ivu-modal-mask) {
  opacity: 0.8 !important;
  background-color: #000;
}

.stats-modal .table-striped tbody tr:nth-of-type(odd) {
  background: #3d3f48 !important;
}

.stats-modal table {
  font-size: small;
  /* table-layout: fixed; */
}

.stats-modal table td,
.stats-modal table th {
  padding: 0.35rem;
  border-color: #333333 !important;
  vertical-align: middle;
}

@media only screen and (max-width: 575.98px) {
  .stats-modal :global(.ivu-modal) {
    margin: 10px auto !important;
    width: 100% !important;
  }
  .stats-modal :global(.ivu-tooltip) {
    width: 110px !important;
    min-width: 110px !important;
  }
}

@media only screen and (max-width: 767.98px) {
  .stats-modal :global(.ivu-modal-header) {
    padding: 10px 10px 0;
  }

  .stats-modal :global(.ivu-modal-body) {
    padding: 10px;
    overflow-x: hidden;
  }

  .stats-modal .table-stats {
    margin-bottom: 0;
  }

  .table-special-div {
    overflow-x: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/brackets/StatsModal.vue